module.exports = __webpack_public_path__ + "img/icon_user_active.539c38f5.png";